export class SoundService {
  private static instance: SoundService;
  private sounds: { [key: string]: HTMLAudioElement } = {};
  private initialized: boolean = false;

  private constructor() {}

  public static getInstance(): SoundService {
    if (!SoundService.instance) {
      SoundService.instance = new SoundService();
    }
    return SoundService.instance;
  }

  public init(): void {
    if (this.initialized) return;

    try {
      this.preloadSound('click', '/sounds/click.wav', 0.2);
      this.preloadSound('success', '/sounds/success.wav', 0.2);
      this.preloadSound('error', '/sounds/error.wav', 0.2);
      
      this.initialized = true;
    } catch (error) {
    }
  }

  private preloadSound(id: string, url: string, volume: number = 1.0): void {
    this.sounds[id] = new Audio(url);
    this.sounds[id].volume = volume;
  }

  public playSound(id: string): void {
    if (!this.initialized) {
      this.init();
    }
    const sound = this.sounds[id];
    if (sound) {
      sound.currentTime = 0;
      sound.play();
    }
  }

  public playClickSound(): void {
    this.playSound('click');
  }

  public playSuccessSound(): void {
    this.playSound('success');
  }

  public playErrorSound(): void {
    this.playSound('error');
  }
}

export const soundService = SoundService.getInstance(); 